/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { User } from './User';
import {
    UserFromJSON,
    UserFromJSONTyped,
    UserToJSON,
} from './User';

/**
 * 
 * @export
 * @interface DashboardWalletUser
 */
export interface DashboardWalletUser {
    /**
     * 
     * @type {string}
     * @memberof DashboardWalletUser
     */
    wallet: string;
    /**
     * 
     * @type {User}
     * @memberof DashboardWalletUser
     */
    user: User;
}

/**
 * Check if a given object implements the DashboardWalletUser interface.
 */
export function instanceOfDashboardWalletUser(value: object): value is DashboardWalletUser {
    let isInstance = true;
    isInstance = isInstance && "wallet" in value && value["wallet"] !== undefined;
    isInstance = isInstance && "user" in value && value["user"] !== undefined;

    return isInstance;
}

export function DashboardWalletUserFromJSON(json: any): DashboardWalletUser {
    return DashboardWalletUserFromJSONTyped(json, false);
}

export function DashboardWalletUserFromJSONTyped(json: any, ignoreDiscriminator: boolean): DashboardWalletUser {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'wallet': json['wallet'],
        'user': UserFromJSON(json['user']),
    };
}

export function DashboardWalletUserToJSON(value?: DashboardWalletUser | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'wallet': value.wallet,
        'user': UserToJSON(value.user),
    };
}

